/*! @azure/msal-react v2.0.22 2024-07-23 */
'use strict';

export { MsalConsumer, MsalContext } from './MsalContext.js';
export { MsalProvider } from './MsalProvider.js';
export { AuthenticatedTemplate } from './components/AuthenticatedTemplate.js';
export { UnauthenticatedTemplate } from './components/UnauthenticatedTemplate.js';
export { MsalAuthenticationTemplate } from './components/MsalAuthenticationTemplate.js';
export { withMsal } from './components/withMsal.js';
export { useMsal } from './hooks/useMsal.js';
export { useAccount } from './hooks/useAccount.js';
export { useIsAuthenticated } from './hooks/useIsAuthenticated.js';
export { useMsalAuthentication } from './hooks/useMsalAuthentication.js';
export { version } from './packageMetadata.js';